import Modal from "../../../components/Modal";
import { fmt, STATUS } from "../constants";

export default function ModalOS({
  modalForm, form, itens, clientes, tecnicos, produtos, pedidos, salvando,
  setF, setItem, selectProduto, addItem, removeItem, buscarCoordenadas,
  salvar, onFechar,
}) {
  if (!modalForm) return null;

  const pedidosDoCliente = form.cliente
    ? pedidos.filter(p => String(p.cliente) === String(form.cliente))
    : [];

  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onFechar}>Cancelar</button>
      <button className="btn btn-primary" onClick={salvar} disabled={salvando}>{salvando?"Salvando...":"Salvar"}</button>
    </>
  );

  return (
    <Modal title={modalForm==="novo"?"Nova OS":"Editar OS"} onClose={onFechar} size="xl" footer={footer}>
      <div className="form-grid">
        <div className="form-group col-span-2">
          <label className="form-label">Cliente</label>
          <select className="form-select" value={form.cliente||""} onChange={e=>setF("cliente",e.target.value)}>
            <option value="">-- Selecione --</option>
            {clientes.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Tipo cliente</label>
          <select className="form-select" value={form.tipo_cliente||"CONSUMIDOR"} disabled>
            <option value="CONSUMIDOR">Consumidor Final</option>
            <option value="ARQ_ENG">Arq/Eng</option>
          </select>
        </div>
        <div className="form-group"><label className="form-label">Tecnico</label><select className="form-select" value={form.tecnico||""} onChange={e=>setF("tecnico",e.target.value)}><option value="">-- Selecione --</option>{tecnicos.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}</select></div>
        <div className="form-group"><label className="form-label">Data agendada</label><input className="form-input" type="datetime-local" value={form.data_agendada||""} onChange={e=>setF("data_agendada",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Status</label><select className="form-select" value={form.status||""} onChange={e=>setF("status",e.target.value)}>{Object.entries(STATUS).map(([v,{l}])=><option key={v} value={v}>{l}</option>)}</select></div>
        <div className="form-group">
          <label className="form-label">Pedido vinculado</label>
          <select className="form-select" value={form.pedido||""} onChange={e=>setF("pedido",e.target.value)} disabled={!form.cliente}>
            <option value="">{form.cliente ? "-- Nenhum --" : "-- Selecione um cliente primeiro --"}</option>
            {pedidosDoCliente.map(p=><option key={p.id} value={p.id}>#{p.id} - {p.cliente_nome}</option>)}
          </select>
        </div>
      </div>
      <div className="form-group"><label className="form-label">Endereco</label><input className="form-input" value={form.endereco||""} onChange={e=>setF("endereco",e.target.value)} placeholder="Rua, numero, bairro"/></div>
      <div className="form-grid">
        <div className="form-group"><label className="form-label">CEP</label><input className="form-input" value={form.cep||""} onChange={e=>setF("cep",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Cidade</label><input className="form-input" value={form.cidade||""} onChange={e=>setF("cidade",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Estado</label><input className="form-input" value={form.estado||""} onChange={e=>setF("estado",e.target.value)} placeholder="SP"/></div>
      </div>
      <div className="flex-row mb-12">
        <button className="btn btn-secondary fs-12" onClick={()=>buscarCoordenadas(form.endereco,form.cidade,form.estado)}><i className="ti ti-map-pin"/> Buscar coordenadas</button>
        {form.latitude&&<span className="fs-12 text-success">✓ {form.latitude}, {form.longitude}</span>}
      </div>
      <div className="form-group"><label className="form-label">Descricao do servico</label><textarea className="form-input" rows={2} value={form.descricao||""} onChange={e=>setF("descricao",e.target.value)}/></div>
      <div className="form-section" style={{marginTop:12}}>Materiais utilizados</div>
      <table style={{width:"100%",fontSize:12,marginBottom:8}}>
        <thead><tr className="bg-page"><th className="td-l">Produto</th><th className="td-r" style={{width:80}}>Qtd</th><th className="td-r" style={{width:120}}>Unit</th><th className="td-r" style={{width:110}}>Total</th><th style={{width:30}}></th></tr></thead>
        <tbody>{itens.map((it,idx)=>(
          <tr key={idx} style={{borderBottom:"1px solid var(--z-border)"}}>
            <td className="td-p"><select className="form-select" style={{fontSize:12,padding:"3px 6px"}} value={it.produto||""} onChange={e=>selectProduto(idx,e.target.value)}><option value="">-- Selecione --</option>{produtos.map(p=><option key={p.id} value={p.id}>{p.codigo} — {p.nome}</option>)}</select></td>
            <td className="td-p"><input type="number" className="form-input" style={{fontSize:12,padding:"3px 6px",textAlign:"right"}} value={it.quantidade} onChange={e=>setItem(idx,"quantidade",e.target.value)}/></td>
            <td className="td-p"><input type="number" className="form-input" style={{fontSize:12,padding:"3px 6px",textAlign:"right"}} value={it.valor_unit} onChange={e=>setItem(idx,"valor_unit",e.target.value)}/></td>
            <td className="td-r fw-600">R$ {fmt(it.valor_total)}</td>
            <td className="td-p"><button className="btn btn-danger" style={{padding:"1px 6px",fontSize:11}} onClick={()=>removeItem(idx)}>×</button></td>
          </tr>
        ))}</tbody>
      </table>
      <button className="btn btn-secondary mb-12 fs-12" onClick={addItem}><i className="ti ti-plus"/> Adicionar material</button>
      <div className="form-grid">
        <div className="form-group"><label className="form-label">Valor mao de obra (R$)</label><input className="form-input" type="number" value={form.valor_mo||""} onChange={e=>setF("valor_mo",e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Total</label><input className="form-input" value={"R$ "+fmt(form.valor_total)} readOnly style={{fontWeight:700,color:"var(--z-blue)",background:"var(--z-bg-page)"}}/></div>
      </div>
      <div className="form-group"><label className="form-label">Observacoes</label><textarea className="form-input" rows={2} value={form.observacoes||""} onChange={e=>setF("observacoes",e.target.value)}/></div>
    </Modal>
  );
}
